import substrateSuggestions from 'owa-substrate-people-suggestions/lib/services/substrateSuggestions';
import shouldUse3SPeopleSuggestions from 'owa-recipient-suggestions/lib/util/shouldUse3SPeopleSuggestions';
import { SuggestionsService } from '../types/SuggestionsService';
import { findPeople } from '../services/findPeople';

export function getSuggestionsService(): SuggestionsService {
    if (shouldUse3SPeopleSuggestions()) {
        return substrateSuggestions;
    } else {
        return findPeople;
    }
}
